/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_Set_Voice_Channel_Status_HintInputs */



/**
* | output |
* | --- |
* | "Allows members to create and edit voice channel status." |
*
* @param {Leveling_Perm_Set_Voice_Channel_Status_HintInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_set_voice_channel_status_hint = /** @type {((inputs?: Leveling_Perm_Set_Voice_Channel_Status_HintInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_Set_Voice_Channel_Status_HintInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Позволяет участникам задавать и менять статус голосового канала.")
	return /** @type {LocalizedString} */ ("Allows members to create and edit voice channel status.")
});